export default __webpack_public_path__ + "static/media/technicalError.5e6e1a88.png";